import { Icon, IconProps } from '@chakra-ui/react'

export default function FoodIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#868E96'}
      {...props}
    >
      <path
        d="M15.8231 12.007L15.8327 13H12.0827C11.8526 13 11.666 12.8135 11.666 12.5833V9.92849C11.666 6.10199 13.5272 3 15.8231 3L15.8327 3.00957L15.825 3V13"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.334 13H15.834V16.75C15.834 17.4404 15.2743 18 14.584 18V18C13.8936 18 13.334 17.4404 13.334 16.75V13Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.25065 9.16699V11.3337"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="5"
        y="11.333"
        width="2.5"
        height="6.66667"
        rx="1.25"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.25065 6.74967V3.20801"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33268 3V7.5C8.33268 8.42047 7.58649 9.16667 6.66602 9.16667H5.83268C4.91221 9.16667 4.16602 8.42047 4.16602 7.5V3"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33268 6.74967H4.16602"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
